<template>
    <div class="setup-wizard">
          <div class="setup-wizard__wrapper">
            <div class="setup-wizard__header">
              <h1 class="setup-wizard__title">KiSoft Genomix <br />Setup</h1>
              <div class="setup-wizard__img-wrapper">
                <img src="@/assets/knapp_logo.svg" alt="KNAPP" class="setup-wizard__header-img" />
              </div>
            </div>
            <div class="setup-wizard__img-center">
              <img src="@/assets/img/setup-wizard/man.png" alt="Image" />
            </div>
            <div class="setup-wizard__footer">
              <span class="setup-wizard__footer-item mb-3">Version 2.4.0</span>
              <span class="setup-wizard__footer-item mb-3">Thank you for choosing Genomix!</span>
              <div class="setup-wizard__footer-item">
                <span
                  >To Complete the system setup, please followthe steps in the setup wizard. If you have any questions or issues please contact
                  support@genomix.com</span
                >
                <div>
                  <v-btn rounded  elevation="0" class="setup-wizard__btn" @click="next">Start</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
</template>

<script>
  export default {
    name: 'SetupWizardStep1',
    methods:{
      next(){
        this.$emit('next');
      }
    }
    
  }
</script>

<style lang="scss" scoped>

</style>
